import type { Environment } from './types/environment.type';

export const environment: Environment = {
  useEmulators: false,
  firebase: {
    apiKey: 'AIzaSyCFPabnzQ-Nov-42XrSRpB616eeDJsNZd0',
    authDomain: 'aphpssj-prod.firebaseapp.com',
    projectId: 'aphpssj-prod',
    storageBucket: 'aphpssj-prod.firebasestorage.app',
    messagingSenderId: '1064827127210',
    appId: '1:1064827127210:web:92f123ad42f7ba66c757d3',
  },
  emulatorHosts: {
    auth: 'http://127.0.0.1:9099',
    firestore: '127.0.0.1:8080',
    storage: '127.0.0.1:9199',
  },
};
